import { api } from '@/services';
import type { ValidarCalculadoraRTCPayload, ValidarCalculadoraRTCResponse } from '../types';

const BASE = 'TurboPro/ApuracaoCBS';

export const validarComCalculadoraRTC = (payload: ValidarCalculadoraRTCPayload) =>
  api.post<ValidarCalculadoraRTCResponse, ValidarCalculadoraRTCPayload>(
    `${BASE}/ValidarCalculadora`,
    payload
  );
